var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.channel
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "spinner-border text-secondary",
              attrs: { role: "status" },
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.$t("global.loading"))),
              ]),
            ]
          ),
        ])
      : _c(
          "div",
          [
            _vm.channel.profiles && _vm.channel.profiles.length
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-warning mb-4",
                    attrs: { role: "alert" },
                  },
                  [
                    _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("watchmen.channels.warn_edit_with_profiles")
                          ) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass:
                          "m-0 mt-1 list-unstyled d-flex flex-column",
                        staticStyle: { gap: "4px" },
                      },
                      _vm._l(_vm.channel.profiles, function (profile) {
                        return _c(
                          "li",
                          { key: profile.id },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "d-flex align-items-center",
                                attrs: {
                                  to: "/configurations/profiles/" + profile.id,
                                },
                              },
                              [
                                _c("ProfileIcon", {
                                  staticClass: "mr-2",
                                  attrs: { icon: profile.icon },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "text-truncate" }, [
                                  _vm._v(_vm._s(profile.name)),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("ChannelForm", {
              staticClass: "mb-4",
              model: {
                value: _vm.channel,
                callback: function ($$v) {
                  _vm.channel = $$v
                },
                expression: "channel",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex pt-3",
                staticStyle: {
                  gap: "1rem",
                  "justify-content": "flex-end",
                  "margin-bottom": "-1rem",
                },
              },
              [
                _c(
                  "Button2",
                  {
                    staticClass: "btn-danger",
                    attrs: {
                      disabled:
                        (_vm.channel.profiles &&
                          !!_vm.channel.profiles.length) ||
                        _vm.isEditSubmitted ||
                        _vm.isDeleteSubmitted,
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleDeleteChannel(_vm.channelId)
                      },
                    },
                  },
                  [
                    _vm.isDeleteSubmitted
                      ? _c("span", {
                          staticClass: "spinner-border spinner-border-sm ml-2",
                          attrs: {
                            role: "status",
                            "aria-label": _vm.$t("global.loading"),
                          },
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("global.delete")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "Button2",
                  {
                    attrs: {
                      disabled:
                        !_vm.channel.value ||
                        _vm.isEditSubmitted ||
                        _vm.isDeleteSubmitted,
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleSaveChannel(_vm.channelId, _vm.channel)
                      },
                    },
                  },
                  [
                    _vm.isEditSubmitted
                      ? _c("span", {
                          staticClass: "spinner-border spinner-border-sm ml-2",
                          attrs: {
                            role: "status",
                            "aria-label": _vm.$t("global.loading"),
                          },
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("global.save")) + "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }